import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProductContext, withProductContext } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import MultipleSaleQtyMessage from "@WhiteCap/Components/MultipleSaleQtyMessage";
import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";


const mapStateToProps = (state: ApplicationState) => ({
    isAuthenticated: state.context.session.isAuthenticated,
});


type Props = ReturnType<typeof mapStateToProps> & HasProductContext;

export interface MultipleSaleQtyContainerStyles {
    multipleSaleQtyContainer?: InjectableCss;
}

export const multipleSaleQtyContainerStyles: MultipleSaleQtyContainerStyles = {
  multipleSaleQtyContainer:{
    css: css`
        margin-top: -5px;
    `
  }
};

const styles = multipleSaleQtyContainerStyles


const MultipleSaleQtyContainer = ({productContext, isAuthenticated}: Props) => {

    if (!productContext || !productContext.product) {
        return null;
    }
   
    return <StyledWrapper {...styles.multipleSaleQtyContainer}><MultipleSaleQtyMessage product={productContext} pageType={"PDP"} isAuthenticated={isAuthenticated}></MultipleSaleQtyMessage></StyledWrapper>;
   
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(withProductContext(MultipleSaleQtyContainer)),
    definition: {
        group: "Basic",
        displayName: "Multiple Sale Qty Container",
    },
};


export default widgetModule;
